<template>
  <div>
    <Title title="Reportería"
           subtitle="Descarga el histórico de SOC por transportista"/>
    <div v-loading="loadReport">
      <el-row>
        <el-form :inline="true">
          <el-form-item>
            <el-select  v-model="enterprise"
                        v-loading="loadEnterprises"
                        class="mini-loader"
                        value-key="id"
                        placeholder="Seleccione empresa"
                        clearable
                        filterable>
              <el-option  v-for="enterprise in enterprises"
                          :key="enterprise.id"
                          :label="enterprise.name"
                          :value="{ id: enterprise.id, name: enterprise.name }"/>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker v-model="dateRange"
                            format="dd-MM-yyyy"
                            type="daterange"
                            range-separator="A"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Seleccione inicio"
                            end-placeholder="Seleccione término">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="search"
                       class="default"
                       :disabled="disabled || loadSearch">
              <i class="fa fa-search"/>
            </el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <div v-loading="loadSearch">
        <div v-if="report" style="height: 430px;">
          <div style="text-align: left">
            <p class="titleRep"><el-icon class="el-icon-s-claim"></el-icon>Resumen reporte</p>
            <el-row :gutter="5">
              <el-col :span="12">
                <el-card shadow="hover" class="boxTit">
                  <div style="text-align: left">
                    <p>Empresa</p>
                  </div>
                  <div class="line"></div>
                  <div style="text-align: left">
                    <p>{{report.enterprise.name}}</p>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="8">
                <el-card shadow="hover" class="boxTit">
                  <div style="text-align: left">
                    <p>Rango Fechas</p>
                  </div>
                  <div class="line"></div>
                  <div style="text-align: left">
                    <p>{{ reportDateRange }}</p>
                  </div>
                </el-card>
              </el-col>
            </el-row>
            <el-row :gutter="5" style="margin-top: 10px;">
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left;"><el-icon class="el-icon-house"></el-icon></div>
                  <div style="text-align: center">
                    <span>{{report.distribution_centers}}</span>
                  </div>
                  <div class="line"></div>
                  <p>Total CT</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><el-icon class="el-icon-guide"></el-icon></div>
                  <div style="text-align: center"><span>{{report.communes}}</span></div>
                  <div class="line"></div>
                  <p>Total Comunas</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><el-icon class="el-icon-position"></el-icon></div>
                  <div style="text-align: center"><span>{{report.routes}}</span></div>
                  <div class="line"></div>
                  <p>Total Rutas</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><el-icon class="el-icon-document"></el-icon></div>
                  <div style="text-align: center"><span>{{report.socs}}</span></div>
                  <div class="line"></div>
                  <p>Total Soc</p>
                </el-card>
              </el-col>
              <el-col :span="4">
                <el-card class="boxRep" shadow="hover">
                  <div style="text-align: left"><el-icon class="el-icon-truck"></el-icon></div>
                  <div style="text-align: center"><span>{{report.trucks}}</span></div>
                  <div class="line"></div>
                  <p>Total Camiones</p>
                </el-card>
              </el-col>
            </el-row>
            <div style="text-align: left">
              <p class="titleRep-2">
          <span style="font-size: 8px;" class="fa-stack small fa-lg tooltipStyle">
            <i class="fas fa-file fa-stack-2x"></i>
            <i class="fas fa-download fa-stack-1x fa-inverse"></i>
          </span>
                Descarga de reporte
              </p>
            </div>
            <div style="text-align: left">
        <span style="font-size: 14px;margin-left: 10px;">El archivo tiene extensión .csv, lo
          puedes abrir con Excel. La separación de las columnas es con punto y coma (;) </span>
            </div>
            <el-row>
              <div v-if="loading" style="text-align: left; margin-top: 10px;">
                <el-button type="primary"
                           icon="el-icon-loading"
                           :disabled="loading"
                           @click="exportReport"
                           size="small">GENERANDO ARCHIVO
                </el-button>
              </div>
              <div v-else style="text-align: left; margin-top: 10px;">
                <el-button type="primary"
                           icon="el-icon-download"
                           @click="exportReport"
                           size="small">DESCARGAR
                </el-button>
              </div>
            </el-row>
          </div>
        </div>
        <div v-else
             class="messageFilter">
          <img class="imageTruck" :src="require('@/assets/img/fb-driver.svg')">
          <p class="titleMessage">Ingresa los filtros para obtener tu reporte</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { saveAs } from 'file-saver';
import Title from '../components/base/Title.vue';
import { cachedAPIRequest } from '../../mixins/cacheDim';
import { apiRequest, getReport2 } from '../../backend/vue-axios/axios';
import {
  getRumDuration,
  startRumTiming,
  trackBusinessFlow,
} from '../../observability/datadogRum';

export default {
  name: 'Reporter',
  components: {
    Title,
  },
  data() {
    return {
      dateRange: null,
      enterprise: '',
      loadSearch: false,
      loadReport: false,
      enterprises: [{ name: 'TODAS', id: 0 }],
      loading: false,
      report: '',
      report2: {
        isLoad: false,
        date_from: '',
        date_up: '',
        total_soc: 0,
        total_routes: 0,
        total_trucks: 0,
        total_communes: 0,
        communes_name: [],
        enterprises_name: [],
        distribution_centers_name: [],
      },
    };
  },
  mounted() {
    this.getEnterprises();
  },
  methods: {
    getEnterprises() {
      cachedAPIRequest({
        module: 'planning',
        service: 'enterprises',
        params: { limit: 6000 },
      }).then((response) => {
        this.enterprises = this.enterprises.concat(response.data);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar las empresas',
        });
      });
    },
    search() {
      this.report = '';
      this.loadSearch = true;
      const startedAt = startRumTiming();
      const params = {
        dateFrom: this.dateRange[0],
        dateUp: this.dateRange[1],
      };
      trackBusinessFlow({
        module: 'reporting',
        flow: 'carrier_report',
        action: 'search_requested',
        status: 'attempt',
        context: {
          has_enterprise_filter: this.enterprise.id > 0,
          report_scope: this.enterprise.id > 0 ? 'enterprise' : 'global',
        },
      });
      if (this.enterprise.id > 0) params.enterprises_id = this.enterprise.id;
      apiRequest({
        module: 'tracing',
        service: 'get_resume_report',
        params,
      }).then((response) => {
        this.report = response.data;
        if (this.enterprise.id > 0) this.report.enterprise = this.enterprise;
        this.report.dateFrom = params.dateFrom;
        this.report.dateUp = params.dateUp;
        trackBusinessFlow({
          module: 'reporting',
          flow: 'carrier_report',
          action: 'search_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            result_routes: response.data.routes,
            result_socs: response.data.socs,
            result_trucks: response.data.trucks,
            distribution_center_count: response.data.distribution_centers,
            distribution_center_scope: response.data.distribution_centers === 0 ? 'none' : response.data.distribution_centers === 1 ? 'single' : 'multiple',
            report_scope: this.enterprise.id > 0 ? 'enterprise' : 'global',
          },
        });
      }).catch((e) => {
        const status = e.response && e.response.status === 404 ? 'empty' : 'error';
        trackBusinessFlow({
          module: 'reporting',
          flow: 'carrier_report',
          action: 'search_completed',
          status,
          durationMs: getRumDuration(startedAt),
          context: {
            http_status: e.response ? e.response.status : 0,
            has_enterprise_filter: this.enterprise.id > 0,
            report_scope: this.enterprise.id > 0 ? 'enterprise' : 'global',
          },
        });
        if (e.response.status === 404) {
          this.$notify.warning({
            title: 'Sin coincidencias',
            message: 'Prueba con datos distintos',
          });
        } else {
          this.$notify.error({
            title: 'Error interno',
            message: 'No se pudo realizar la consulta',
          });
        }
      }).finally(() => {
        this.loadSearch = false;
      });
    },
    formatDate(date) {
      return moment.utc(date).format('DD-MM-YYYY');
    },
    exportReport() {
      this.loadReport = true;
      this.$message({ message: 'Generando resumen del reporte' });
      const startedAt = startRumTiming();
      const params = {
        dateFrom: this.report.dateFrom,
        dateUp: this.report.dateUp,
      };
      trackBusinessFlow({
        module: 'reporting',
        flow: 'carrier_report',
        action: 'export_requested',
        status: 'attempt',
        context: {
          has_enterprise_filter: this.report.enterprise.id > 0,
          distribution_center_count: this.report.distribution_centers,
          distribution_center_scope: this.report.distribution_centers === 0 ? 'none' : this.report.distribution_centers === 1 ? 'single' : 'multiple',
          report_scope: this.report.enterprise.id > 0 ? 'enterprise' : 'global',
        },
      });
      if (this.report.enterprise.id > 0) params.enterprises_id = this.report.enterprise.id;
      getReport2({
        module: 'tracing',
        service: 'get_report',
        pathparams: params,
      }).then((response) => {
        return response.status === 200 ? response.blob() : null;
      }).then((blob) => {
        this.loadReport = false;
        saveAs(blob, 'reporte-planificacion.csv');
        trackBusinessFlow({
          module: 'reporting',
          flow: 'carrier_report',
          action: 'export_completed',
          status: 'success',
          durationMs: getRumDuration(startedAt),
          context: {
            distribution_center_count: this.report.distribution_centers,
            distribution_center_scope: this.report.distribution_centers === 0 ? 'none' : this.report.distribution_centers === 1 ? 'single' : 'multiple',
            report_scope: this.report.enterprise.id > 0 ? 'enterprise' : 'global',
          },
        });
      }).catch((e) => {
        this.loadReport = false;
        trackBusinessFlow({
          module: 'reporting',
          flow: 'carrier_report',
          action: 'export_completed',
          status: 'error',
          durationMs: getRumDuration(startedAt),
          context: {
            error_message: e.message,
            distribution_center_count: this.report.distribution_centers,
            distribution_center_scope: this.report.distribution_centers === 0 ? 'none' : this.report.distribution_centers === 1 ? 'single' : 'multiple',
            report_scope: this.report.enterprise.id > 0 ? 'enterprise' : 'global',
          },
        });
        const messageRes = e.message;
        this.$notify.error({
          title: 'Error',
          message: `${messageRes}`,
        });
      });
    },
  },
  computed: {
    disabled() {
      return this.dateRange === null || this.enterprise === '';
    },
    loadEnterprises() {
      return this.enterprises.length < 2;
    },
    reportDateRange() {
      return this.report.dateFrom && this.report.dateUp
        ? `DEL ${this.formatDate(this.report.dateFrom)}
        AL ${this.formatDate(this.report.dateUp)}` : '';
    },
  },
};

</script>

<style lang="scss" scoped>
  .boxRep {
    border-radius: 10px;
    height: 170px;
    position: relative;
    span {
      font-size: 40px;
      font-weight: 300;
      line-height: 70px;
      color: #707070;
    }
    .el-icon-position {
      font-size: 30px;
      color: #AAD500;
      margin: -15px 0 0 -15px;
    }
    .el-icon-document{
      font-size: 30px;
      color: #AAD500;
      margin: -15px 0 0 -15px;
    }
    .el-icon-truck {
      font-size: 35px;
      color: #AAD500;
      margin: -15px 0 0 -15px;
    }
    .el-icon-guide{
      font-size: 30px;
      color: #AAD500;
      margin: -15px 0 0 -15px;
    }
    .el-icon-house{
      font-size: 30px;
      color: #AAD500;
      margin: -15px 0 0 -15px;
    }
    .el-icon-download {
      font-size: 50px;
      line-height: 90px;
    }
    .line {
      height: 2px;
      margin-top: 0px;
      background: #AAD500;
    }
    p {
      font-size: 12px;
      color: #707070;
      margin: 10px 0 10px 0;
      text-transform: uppercase;
    }
  }
  .boxTit {
    border-radius: 10px;
    height: 100px;
    position: relative;
    span {
      font-size: 40px;
      font-weight: 300;
      line-height: 70px;
      color: #707070;
    }
    .line {
      height: 2px;
      margin-top: 0px;
      background: #AAD500;
    }
    p {
      font-size: 12px;
      color: #707070;
      margin: 10px 0 10px 0;
      text-transform: uppercase;
    }
  }
  .el-icon-s-claim {
    color: #AAD500;
    margin-right: 8px;
  }
  .searchBttn {
    height: 40px;
  }
  .titleRep {
    color: #707070;
    font-size: 15px;
    text-transform: uppercase;
    margin-bottom: 25px;
  }
  .titleRep-2 {
    color: #707070;
    font-size: 15px;
    text-transform: uppercase;
    margin-bottom: 5px;
  }
  .wrap {
    display: block;
  }
  .tooltipStyle {
    color: #AAD500;
    font-size: 16px;
  }
  .messageFilter{
    text-align: center;
    background-color: #ffffff;
    height: 500px;
    margin-left:5px;
    .titleMessage{
      margin-top: 40px;
      color: #AAD500;
      font-size: 16px;
      text-transform: uppercase;
    }
    .imageTruck{
      height: 200px;
      margin-top: 50px;
    }
  }
  .el-form {
    .el-button { height: 40px; }
    .el-date-editor { margin-top: 1px; }
  }
</style>
